export var CustomerGender;
(function (CustomerGender) {
    CustomerGender["MALE"] = "MALE";
    CustomerGender["FEMALE"] = "FEMALE";
})(CustomerGender || (CustomerGender = {}));
